<template>
    <b-modal :modal-class="`modal-${variant} modal-min-btn`"
             v-model="isOpen"
             :title="title"
             hide-header-close
             centered
             :cancel-title="cancelTitle"
             @cancel="onCancel"
             cancel-variant="light"
             @ok="onOk"
             @hidden="onHidden"
             :ok-title="okTitle"
             :ok-variant="variant"
             no-close-on-backdrop
             ref="modal">
        <slot>
            <div v-html="message"></div>
        </slot>
    </b-modal>
</template>

<script>
import modalDialog from "@/plugins/dialogs/mixins/modalDialog";

export default {
    name: "Confirm",
    mixins: [modalDialog],
    props: {
        cancelTitle: {default: 'CANCEL'},
        okTitle: {default: 'OK'},
        variant: {default: 'primary'},
        title: {default: 'Confirm'},
        message: {default: '<b>Are you sure?</b>'}
    },
}
</script>

<style scoped>

</style>
